/* eslint-disable max-classes-per-file */
export interface RequestTourDestinationsInterface {
  destinationType: string;
  limit: number;
  page: number;
}

export interface TourDestinationsSEOInterface {
  domestic: Array<TourDestinationsItem>;
  international: Array<TourDestinationsItem>;
}

export interface TourDestinationsDataInterface {
  countryId: number;
  cityName: string;
  countrySlug: string;
  citySlug: string;
  countryName: string;
  cityId: number;
}

export class TourDestinationsItem {
  countryId: number;

  countrySlug: string;

  countryName: string;

  cityId: number;

  citySlug: string;

  cityName: string;

  constructor(data: any) {
    this.countryId = data.countryId || 0;
    this.countrySlug = data.countrySlug || "";
    this.countryName = data.countryName || "";
    this.cityId = data.cityId || 0;
    this.citySlug = data.citySlug || "";
    this.cityName = data.cityName || "";
  }
}

export class ResponseTourDestinations {
  status: string;

  message: string;

  cache: number;

  data: TourDestinationsItem[];

  constructor(res: any) {
    this.status = res?.status || false;
    this.message = res?.message || "";
    this.cache = res?.cache || 0;
    this.data = (res?.data || []).map(
      (item: any) => new TourDestinationsItem(item),
    );
  }
}

export interface RequestTourPackageDestinationInterface {
  countrySlug?: string;
  citySlug?: string;
}

export interface RequestTourLandingPageInterface {
  countrySlug?: string;
  citySlug?: string;
  url?: string;
}

export class ResponseTourPackageDestination {
  countryId: number;

  countrySlug: string;

  countryName: string;

  cityId: number;

  citySlug: string;

  cityName: string;

  constructor(res: any) {
    this.countryId = res?.countryId || "";
    this.countrySlug = res?.countrySlug || "";
    this.countryName = res?.countryName || "";
    this.cityId = res?.cityId || "";
    this.citySlug = res?.citySlug || "";
    this.cityName = res?.cityName || "";
  }
}

export class ResponseTourLandingPage {
  countrySlug: string;

  countryName: string;

  citySlug: string;

  cityName: string;

  countryLatitude?: number;

  countryLongitude?: number;

  cityLatitude?: number;

  cityLongitude?: number;

  constructor(res: any) {
    this.countrySlug = res?.countrySlug || "";
    this.countryName = res?.countryName || "";
    this.citySlug = res?.citySlug || "";
    this.cityName = res?.cityName || "";
    this.countryLatitude = res?.countryLatitude || "";
    this.countryLongitude = res?.countryLongitude || "";
    this.cityLatitude = res?.cityLatitude || "";
    this.cityLongitude = res?.cityLongitude || "";
  }
}
